/**
 * A function to scroll to the section specified in the URL on a longform.
 */
const longformScroller = () => {
  // Look at URL to see if it has /section/ in it.
  const matches = window.location.pathname.match(/\/section\/([^/]+)/);
  if (matches) {
    // Try to find a component with an ID that matches the section.
    const heading = document.getElementById(matches[1]);
    if (heading) {
      /*
       * Scroll the component to the center of the viewport.
       * Note: Centering does not work in Safari or Internet Explorer,
       * so the element will scroll to the top of the viewport, which
       * may put it behind sticky elements in the header. However, this
       * solution is a lot cleaner than trying to detect sticky stuff
       * at the top of the page and calculating an offset.
       */
      heading.scrollIntoView({ block: 'center' });
    }
  }
};

window.addEventListener('load', longformScroller);
